import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from "@mui/material";
import { Form, Field } from "react-final-form";

interface PlaylistModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (formData: any) => void;
}

const PlaylistModal = ({ open, onClose, onSubmit }: PlaylistModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "600px",
          borderRadius: "15px",
          padding: "20px",
        },
      }}
    >
      <DialogTitle>Add New Playlist</DialogTitle>
      <DialogContent>
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={2}>
                <Field name="field1">
                  {({ input }) => (
                    <TextField
                      label="Field 1"
                      variant="outlined"
                      fullWidth
                      {...input}
                      autoFocus
                    />
                  )}
                </Field>
              </Box>
              <Box mt={2}>
                <Field name="field2">
                  {({ input }) => (
                    <TextField
                      label="Field 2"
                      variant="outlined"
                      fullWidth
                      {...input}
                    />
                  )}
                </Field>
              </Box>
              <Box mt={2} mb={2}>
                <Field name="field3">
                  {({ input }) => (
                    <TextField
                      label="Field 3"
                      variant="outlined"
                      fullWidth
                      {...input}
                    />
                  )}
                </Field>
              </Box>

              <DialogActions>
                <Button onClick={onClose} color="primary">
                  Cancel
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  Add
                </Button>
              </DialogActions>
            </form>
          )}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PlaylistModal;
